// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

import { BootstrapVue, IconsPlugin, BootstrapVueIcons } from 'bootstrap-vue';
import Vue from 'vue';
import { createApp } from 'vue';
import VueCookies from 'vue-cookies'
import { router } from '@/app.router';
import { store } from '@/store/model.store';
import VueResizeText from "vue3-resize-text"

import { CustomIconsPlugin } from '../icons';
import AsyncComputed from 'vue-async-computed';
// TODO: will need to change at some point
import CKEditor from 'ckeditor4-vue/dist/ckeditor';
import VuePluralize from 'vue-pluralize';
// 
import { defineRule } from 'vee-validate';
import { min, max, min_value, regex, required, numeric, digits, email, integer } from '@vee-validate/rules';

import { VueRecaptchaPlugin } from 'vue-recaptcha/head';

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";

import PlanoramaApp from '../app.vue';

Vue.use(BootstrapVue, {
  BSkeleton: { animation: 'fade' }
});

Vue.use(VueCookies, {
  // options here
});

defineRule('min', min);
defineRule('max', max);
defineRule('regex', regex);
defineRule('email', email);
defineRule('numeric', numeric);
defineRule('digits', digits);
defineRule('integer', integer);
defineRule('min_value', min_value);

// We need required to allow false as a valid value
defineRule('required', value => {
  if (typeof value == "boolean") {
    return true
  }

  if (!value || !value.length) {
    return false
    // return 'This field is required';
  }

  return true;
});

// NOTE: this is needed while the app is using vue compat for vue2 components
// the draggable component needs the vue3 rendering ...
import { VueDraggableNext } from 'vue-draggable-next'
VueDraggableNext.compatConfig = { MODE: 3 }

Vue.use(IconsPlugin)
Vue.use(BootstrapVueIcons)
Vue.use(CustomIconsPlugin);
Vue.use(AsyncComputed);
Vue.use(CKEditor);
Vue.use(VuePluralize);

const app = createApp(PlanoramaApp);
// This is done to get a handle on the
// app from within the router
app.provide('PlanoramaApp', app)

if (RECAPTCHA_SITE_KEY) {
  app.use(VueRecaptchaPlugin, {
    v2SiteKey: RECAPTCHA_SITE_KEY
    // v3SiteKey: 'YOUR_V3_SITEKEY_HERE',
  })
}

// See/review https://enterprisevue.dev/blog/error-handling-in-vue-3/
app.config.errorHandler = (err, vm, info) => {
  console.error("Error:", err);
  // console.error("Vue component:", vm);
  // console.error("Additional info:", info);
  if (!import.meta.env.DEV || (err?.response && err.response?.status !== 422)) {
    window.alert("Whoops! We messed up! Click ok to reload the page.")
    window.location.reload();
  }
};

app.use(VueResizeText)
app.use(router)   // Set up the router
app.use(store)    // Set up the store

// app.use({
//   install() {
//     window._ = _;
//     app.config.globalProperties.window = window; // somehow this is needed?
//     app.config.globalProperties._ = _;
//   }
// });

app.mount('#app') // Display app using element with id 'app'
